export const shouldLoad = () => !!document.querySelector('.klt-field :is(input, textarea)[maxlength]');
